module.exports = __webpack_public_path__ + "img/BIT_white37.449e9205.jpg";